// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"89b9af03","598":"77d9e89f"}[chunkId] + ".chunk.js";
};